import request from './request';

// 获取所有模型（支持分页）
export function getModels(params = {}) {
  return request({
    url: '/models',
    method: 'get',
    params
  });
}

// 根据ID获取模型
export function getModelById(id) {
  return request({
    url: `/models/${id}`,
    method: 'get'
  });
}

// 创建模型
export function createModel(data) {
  return request({
    url: '/models',
    method: 'post',
    data
  });
}

// 更新模型
export function updateModel(id, data) {
  return request({
    url: `/models/${id}`,
    method: 'put',
    data
  });
}

// 删除模型
export function deleteModel(id) {
  return request({
    url: `/models/${id}`,
    method: 'delete'
  });
}

// 批量创建模型
export function batchCreateModels(models) {
  return request({
    url: '/models/batch',
    method: 'post',
    data: { models }
  });
}

// 获取默认模型列表
export function getDefaultModels() {
  return request({
    url: '/models/default/list',
    method: 'get'
  });
}

// 获取后台模型列表
export function getBackendModels() {
  return request({
    url: '/models/backend/list',
    method: 'get'
  });
}

